import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg width="17" height="17" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M1.273 5.175V1.973L4.075 3.62 1.273 5.175zM6.076 3.174h9.607v.801H6.076zM1.273 8.377h14.41v.801H1.273zM1.273 13.581h14.41v.801H1.273z" fill="#fff" /></svg>;